import { render, staticRenderFns } from "./InviteCollaboratorModal.vue?vue&type=template&id=261d3e44"
import script from "./InviteCollaboratorModal.vue?vue&type=script&lang=ts"
export * from "./InviteCollaboratorModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports